import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { pickHTMLProps } from 'pick-react-known-prop';
import IconButton from '@material-ui/core/IconButton';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'row',
      alignContent: 'center',
      alignItems: 'center',
      width: '100%'
    },
    content: {
      overflowX: 'auto',
      '&::-webkit-scrollbar': {
        display: 'none'
      },
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      '& > div': {
        flexGrow: 1,
        flexShrink: 1,
        width: function width(_ref) {
          var showNum = _ref.showNum;
          return "calc(100% / ".concat(showNum, ")");
        },
        minWidth: function minWidth(_ref2) {
          var showNum = _ref2.showNum;
          return "calc(100% / ".concat(showNum, ")");
        },
        flexBasis: function flexBasis(_ref3) {
          var showNum = _ref3.showNum;
          return "calc(100% / ".concat(showNum, ")");
        }
      }
    },
    headline: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      paddingBottom: theme.spacing(2),
      flexWrap: 'wrap'
    },
    arrows: _defineProperty({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }, theme.breakpoints.down('sm'), {
      display: 'none'
    }),
    container: {
      width: '100%',
      maxWidth: '100%'
    }
  };
}, {
  name: 'SxComComponentTop'
});
var ComponentTop = /*#__PURE__*/React.forwardRef(function ComponentTop(_ref4, ref) {
  var active = _ref4.active,
      children = _ref4.children,
      pClasses = _ref4.classes,
      className = _ref4.className,
      disabledLeft = _ref4.disabledLeft,
      disabledRight = _ref4.disabledRight,
      handleMove = _ref4.handleMove,
      hideArrows = _ref4.hideArrows,
      IconLeftComponent = _ref4.IconLeftComponent,
      IconRightComponent = _ref4.IconRightComponent,
      onActiveChange = _ref4.onActiveChange,
      showNum = _ref4.showNum,
      Title = _ref4.title,
      TitleProps = _ref4.TitleProps,
      TransitionComponent = _ref4.TransitionComponent,
      TransitionProps = _ref4.TransitionProps,
      rest = _objectWithoutProperties(_ref4, ["active", "children", "classes", "className", "disabledLeft", "disabledRight", "handleMove", "hideArrows", "IconLeftComponent", "IconRightComponent", "onActiveChange", "showNum", "title", "TitleProps", "TransitionComponent", "TransitionProps"]);

  var classes = useStyles({
    classes: pClasses,
    className: className,
    showNum: showNum
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headline
  }, /*#__PURE__*/React.createElement(Title, _extends({
    onSlide: handleMove,
    active: active,
    onActiveChange: onActiveChange
  }, TitleProps)), !hideArrows && /*#__PURE__*/React.createElement("div", {
    className: classes.arrows
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleMove(-1),
    disabled: disabledLeft
  }, /*#__PURE__*/React.createElement(IconLeftComponent, null)), /*#__PURE__*/React.createElement(IconButton, {
    onClick: handleMove(1),
    disabled: disabledRight
  }, /*#__PURE__*/React.createElement(IconRightComponent, null)))), /*#__PURE__*/React.createElement("div", _extends({}, pickHTMLProps(rest), {
    className: clsx(classes.root, className)
  }), /*#__PURE__*/React.createElement(TransitionComponent, _extends({
    in: true
  }, TransitionProps), /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: classes.content
  }, children, " "))));
});
ComponentTop.propTypes = {
  active: PropTypes.number,
  cardCount: PropTypes.number,
  children: PropTypes.node,
  classes: PropTypes.shape({
    arrows: PropTypes.string,
    container: PropTypes.string,
    content: PropTypes.string,
    headline: PropTypes.string,
    root: PropTypes.string
  }),
  className: PropTypes.string,
  disabledLeft: PropTypes.bool,
  disabledRight: PropTypes.bool,
  handleMove: PropTypes.func,
  hideArrows: PropTypes.bool,
  IconLeftComponent: PropTypes.elementType,
  IconRightComponent: PropTypes.elementType,
  onActiveChange: PropTypes.func,
  showNum: PropTypes.number,
  title: PropTypes.elementType,
  TitleProps: PropTypes.shape({}),
  TransitionComponent: PropTypes.elementType,
  TransitionProps: PropTypes.shape({})
};
ComponentTop.defaultProps = {
  active: undefined,
  cardCount: 4,
  children: null,
  classes: undefined,
  className: undefined,
  disabledLeft: false,
  disabledRight: false,
  handleMove: undefined,
  hideArrows: false,
  IconLeftComponent: undefined,
  IconRightComponent: undefined,
  onActiveChange: undefined,
  showNum: undefined,
  title: undefined,
  TitleProps: undefined,
  TransitionComponent: undefined,
  TransitionProps: undefined
};
export default ComponentTop;